import React from "react";
import { Typography } from "@mui/material";
import { useSearchParams, useParams, Link as RouterLink } from "react-router-dom";
import { IconCircleCheckFilled, IconCircleXFilled, IconClockFilled } from "@tabler/icons-react";

import CustomButton from "@components/button/customButton";

import { useTranslation } from "react-i18next";

import "./status.css";

export default function PaymentStatus() {
  const { t } = useTranslation() 
  const [searchParams] = useSearchParams();
  // const { pathname } = useLocation();
  // const pageAction = pathname.split("/")[3] || null; // get from pathname expected values ["application", "donation"]
  const status_id = searchParams.get("status_id");
  const { id } = useParams()

  const paymentLink = id ? `/payment/application/${id}` : '/payment'

  return (
    <div
      className="admin-error"
    >
      {
        status_id === "1" ?
        <>
          <IconCircleCheckFilled size={88} color="#A1C558" />
          <Typography className="title">
            {t('payment-page.paymentSuccess')}
          </Typography>
          <Typography className="description">
            {t('payment-page.paymentSuccessDesc')}
          </Typography>
          <CustomButton component={RouterLink} to={'/'}>{t('payment-page.returnToHome')}</CustomButton>
        </>
        :
        status_id === "3" ?
        <>
          <IconCircleXFilled size={88} color="#D13F58" />
          <Typography className="title">
            {t('payment-page.paymentFailed')}
          </Typography>
          <Typography className="description" sx={{mb: '18px'}}>
            {t('payment-page.paymentFailedDesc')}
          </Typography>
          <CustomButton component={RouterLink} to={paymentLink}>{t('payment-page.returnToPayment')}</CustomButton>
        </>
        :
        <>
          <IconClockFilled size={88} color="#FFD044" />
          <Typography className="title">
            {t('payment-page.paymentPending')}
          </Typography>
          <Typography className="description">
            {t('payment-page.paymentPendingDesc')}
          </Typography>
          <CustomButton component={RouterLink} to={'/'}>{t('payment-page.returnToHome')}</CustomButton>
        </>
      }
    </div>
  );
}
